const COLOR = {
  SPARTAN: 'red',
  FARINATO: 'green',
};

const races = [
  {
    id: 200,
    title: 'Spartan Race 2020',
    date: '01/01/2020',
    color: COLOR.SPARTAN,
    shortDescription: 'Spartan Race 2020 Madrid',
    coordinates: [40.4167, -3.70325],
  },
  {
    id: 201,
    title: 'Farinato Race',
    date: '11/01/2020',
    color: COLOR.FARINATO,
    shortDescription: 'Farinato Race 2020 Cataluña',
    coordinates: [41.3887901, 2.1589899],
  },
];

export const titleToUrl = title => title.replace(/ /g, '-');

export default races;
